module.exports = "/static/assets/95be8547447707daedc68ea89d7b9370.gif";